import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import '../styles/cultural-platform.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for reaching out! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      organization: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-page" data-testid="contact-page">
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #F8F9FA 0%, #FFFFFF 100%)',
        padding: '100px 24px 80px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h1 className="cultural-hero-title">Get In Touch</h1>
          <p style={{
            fontSize: '18px',
            color: 'var(--text-secondary)',
            marginTop: '16px',
            lineHeight: '1.7'
          }}>
            Connect with us to explore partnerships, collaborations, or learn more about 
            our global cultural initiatives.
          </p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section style={{ 
        background: 'var(--primary-white)',
        padding: '80px 24px'
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '48px'
        }}>
          {/* Contact Form */}
          <div style={{ gridColumn: 'span 2' }}>
            <h2 className="cultural-section-title" style={{ marginBottom: '12px' }}>
              Send Us a Message
            </h2>
            <p style={{
              fontSize: '16px',
              color: 'var(--text-secondary)',
              marginBottom: '32px'
            }}>
              Whether you're interested in partnerships, cultural projects, or have questions about our work, 
              we'd love to hear from you.
            </p>

            <form onSubmit={handleSubmit} data-testid="contact-form">
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
                gap: '20px' 
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '500',
                    fontSize: '14px',
                    color: 'var(--text-primary)'
                  }}>
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    data-testid="contact-name-input"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '1px solid var(--surface-dark)',
                      borderRadius: '4px',
                      fontFamily: 'var(--font-body)',
                      fontSize: '16px',
                      transition: 'border-color 0.2s'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '500',
                    fontSize: '14px',
                    color: 'var(--text-primary)'
                  }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    data-testid="contact-email-input"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '1px solid var(--surface-dark)',
                      borderRadius: '4px',
                      fontFamily: 'var(--font-body)',
                      fontSize: '16px',
                      transition: 'border-color 0.2s'
                    }}
                  />
                </div>
              </div>

              <div style={{ marginTop: '20px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '500',
                  fontSize: '14px',
                  color: 'var(--text-primary)'
                }}>
                  Organization
                </label>
                <input
                  type="text"
                  name="organization"
                  value={formData.organization}
                  onChange={handleChange}
                  data-testid="contact-organization-input"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid var(--surface-dark)',
                    borderRadius: '4px',
                    fontFamily: 'var(--font-body)',
                    fontSize: '16px',
                    transition: 'border-color 0.2s'
                  }}
                />
              </div>

              <div style={{ marginTop: '20px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '500',
                  fontSize: '14px',
                  color: 'var(--text-primary)'
                }}>
                  Subject *
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  data-testid="contact-subject-input"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid var(--surface-dark)',
                    borderRadius: '4px',
                    fontFamily: 'var(--font-body)',
                    fontSize: '16px',
                    transition: 'border-color 0.2s'
                  }}
                />
              </div>

              <div style={{ marginTop: '20px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '500',
                  fontSize: '14px',
                  color: 'var(--text-primary)'
                }}>
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  data-testid="contact-message-input"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid var(--surface-dark)',
                    borderRadius: '4px',
                    fontFamily: 'var(--font-body)',
                    fontSize: '16px',
                    resize: 'vertical',
                    transition: 'border-color 0.2s'
                  }}
                />
              </div>

              <button
                type="submit"
                className="cultural-cta"
                data-testid="contact-submit-btn"
                style={{ 
                  marginTop: '24px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                Send Message <Send size={18} />
              </button>
            </form>
          </div>

          {/* Quick Contact Info */}
          <div>
            <h3 style={{
              fontFamily: 'var(--font-primary)',
              fontSize: '20px',
              fontWeight: '500',
              marginBottom: '24px',
              color: 'var(--text-primary)'
            }}>
              Quick Contact
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              <div style={{ display: 'flex', gap: '16px' }}>
                <div style={{
                  flexShrink: 0,
                  width: '48px',
                  height: '48px',
                  borderRadius: '8px',
                  background: 'var(--accent-blue)',
                  color: 'var(--primary-white)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Mail size={22} />
                </div>
                <div>
                  <p style={{ fontWeight: '500', fontSize: '14px', marginBottom: '4px' }}>Email</p>
                  <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                    info@projectsoftpower.org
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '16px' }}>
                <div style={{
                  flexShrink: 0,
                  width: '48px',
                  height: '48px',
                  borderRadius: '8px',
                  background: '#10B981',
                  color: 'var(--primary-white)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Phone size={22} />
                </div>
                <div>
                  <p style={{ fontWeight: '500', fontSize: '14px', marginBottom: '4px' }}>Phone</p>
                  <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                    +91 9677774667
                  </p>
                </div>
              </div>
              <div style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #E8EAED' }}>
                <p style={{ fontSize: '14px', color: 'var(--text-secondary)', fontStyle: 'italic', lineHeight: '1.5' }}>
                  An international organization operating across cultures and borders.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
